import Controller from '@ember/controller';
import { service, type Registry as Services } from '@ember/service';

import { Router } from 'register-partners-js/react/router.tsx';

export default class RouterController extends Controller {
  @service declare router: Services['router'];
  ReactRouter = Router;

  get path() {
    return this.router.currentRoute.params.path;
  }
}
